import React from 'react';
import { connect } from 'react-redux';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';
import { Panel, PanelPresets, UserPermissionsIds } from '../../utility/enumerations';

function TransporterContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/transporters/list"
        pathPermissionId={UserPermissionsIds.AccessTransporters}
        render={(props) => ViewMounter(props, {
          viewPath: 'transporter/transporters',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: undefined,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/transporters/transporterdetails/:id"
        pathPermissionId={UserPermissionsIds.ReadTransporters}
        render={(props) => ViewMounter(props, {
          viewPath: 'transporter/transporter_details',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
      />
      <SecureRoute
        path="/transporters/add"
        pathPermissionId={UserPermissionsIds.CreateTransporters}
        render={(props) => {
          return (
            ViewMounter(props, {
              viewPath: 'transporter/add_transporter/add_transporter',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              focusView: true,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              params: undefined
            })
          );
        }}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/transporters/import"
        pathPermissionId={UserPermissionsIds.CreateTransporters}
        render={(props) => {
          return (
            ViewMounter(props, {
              viewPath: 'transporter/add_transporter/import_transporter',
              targetPanel: Panel.Primary,
              panelLayout: PanelPresets.OneFull,
              focusView: true,
              clear: true,
              viewProps: undefined,
              overrideLocation: undefined,
              params: undefined
            })
          );
        }}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    empty: state.empty,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(TransporterContainerScreen);
